import React from "react";

interface ShinyTextProps {
  text: string;
  disabled?: boolean;
  speed?: number;
  className?: string;
}

const ShinyText: React.FC<ShinyTextProps> = ({
  text,
  disabled = false,
  speed = 5,
  className = "",
}) => {
  const animationDuration = `${speed}s`;

  return (
    <span
      className={`inline-block ${disabled ? "" : "animate-shine"} ${className}`}
      style={{
        color: "transparent",
        backgroundImage:
          "linear-gradient(120deg, rgba(228, 222, 215, 0.6) 0%, rgba(228, 222, 215, 0.6) 40%, rgba(255, 255, 255, 1) 50%, rgba(228, 222, 215, 0.6) 60%, rgba(228, 222, 215, 0.6) 100%)",
        backgroundSize: "200% 100%",
        WebkitBackgroundClip: "text",
        backgroundClip: "text",
        animationDuration: animationDuration,
        animationTimingFunction: "linear",
        animationIterationCount: "infinite",
        overflow: "visible",
        display: "inline-block",
        whiteSpace: "normal",
      }}
    >
      {text}
    </span>
  );
};

export default ShinyText;
